<template>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <Form ref="empruntForm" @submit="editEmprunt" :validation-schema="empruntSchema" :initial-values="empruntForm">
            <div class="row">
                <div class="col-md-4">
                    <label for="dateDebut" class="form-label">Date Debut<span class="text-danger">*</span></label>
                    <Field name="dateDebut" class="form-control" type="number"/>
                    <ErrorMessage name="dateDebut" class="text-danger" />
            </div>

            <div class="col-md-4">
                    <label for="dateFin" class="form-label">Date Fin<span class="text-danger">*</span></label>
                    <Field name="dateFin" class="form-control" type="number"/>
                    <ErrorMessage name="dateFin" class="text-danger" />
            </div>

            <div class="col-md-4">
                    <label for="statut" class="form-label">Statut<span class="text-danger">*</span></label>
                    <Field name="statut" class="form-control" type="text"/>
                    <ErrorMessage name="statut" class="text-danger" />
            </div>
           
              <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black mb-10">
                                Document <span class="text-danger">*</span>
                            </label>
                            <Field name="document" v-model="documents" type="text" v-slot="{ field }">
                                <Multiselect v-model="field.value" v-bind="field" :options="documentOptions"
                                    :preserve-search="true" :multiple="false" :searchable="true"
                                    placeholder="Sélectionner le document" label="label" track-by="label" />
                            </Field>
                            <span class="text-danger" v-if="showMErr">Le document est obligatoire</span>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black mb-10">
                                User <span class="text-danger">*</span>
                            </label>
                            <Field name="user" type="text" v-slot="{ field }">
                                <Multiselect v-model="field.value" v-bind="field" :options="userOptions"
                                    :preserve-search="true" :multiple="false" :searchable="true"
                                    placeholder="Sélectionner l'utilisateur" label="label" track-by="label" />
                            </Field>
                            <ErrorMessage name="user" class="text-danger" />
                        </div>
                    </div>
              
          <div class="col-md-12 d-flex flex-column mt-3">
            <div class="d-flex align-items-center ">
              <button
                class="btn btn-success me-3"
                type="submit"
              >
                  Modifier Emprunt
              </button>
              <router-link to="/emprunts/liste-emprunt" 
                  class=" btn btn-danger"><i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                  <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
  </template>
  

  <script lang="ts">
  import { defineComponent, ref, onMounted } from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import { error, success } from '@/utils/utils';
  import { useRoute, useRouter } from 'vue-router';
  import ApiService from '@/services/ApiService';
  import { Emprunt} from '@/models/Emprunt';
  import * as Yup from 'yup';
  import axios from 'axios';
  import Multiselect from '@vueform/multiselect'
  
  export default defineComponent({
      name: "EditEmprunt",
      components: {
      Form,
      Field,
      ErrorMessage,
      Multiselect
    },
    setup: () => {
      const empruntSchema = Yup.object().shape({
        dateDebut: Yup.string().required("La Date Debut est obligatoire."),
        dateFin: Yup.string().required("La Date Fin est obligatoire."),
        statut: Yup.string().required("Le statut est obligatoire."),
        user: Yup.string().required("L'utilisateur est obligatoire."),
        document: Yup.string().required("Le document est obligatoire."),

      });
  
      const empruntForm = ref<Emprunt>();
        const showMErr = ref(false);
        const documents = ref();
        const userOptions = ref();
        const documentOptions = ref([]);
      const router = useRouter();
      const route = useRoute();
  
      onMounted(() => {
        getAllUsers();
        getAllDocuments();
        if(route.params.id) {
          getEmprunt(parseInt(route.params.id as string));
        }
      });
  
      function getEmprunt(id:number) {
        ApiService.get("/emprunts/"+id.toString())
          .then(({ data }) => {
            for (const key in data.data) {
              empruntForm.value?.setFieldValue(key, 
              (typeof data.data[key] === 'object' && data.data[key] !== null)? data.data[key].id :data.data[key]
            );
            }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
      }
      
      const getAllUsers = async () => {
            try{
            const response = await ApiService.get('/all/users');
            const usersData = response.data.data.data;
            console.log('Data', usersData)
            userOptions.value = usersData.map((user) => ({
              value: user.id,
              label: user.nom,
            }));
            }
            catch(error){
              //error(response.data.message)
            }
          }
          const getAllDocuments= async () => {
            try{
            const response = await ApiService.get('/all/documents');
            const documentsData = response.data.data.data;
            documentOptions.value = documentsData.map((document) => ({
              value: document.id,
              label: document.titre,
            }));
            }
            catch(error){
              //error(response.data.message)
            }
          } 
  
  
  const editEmprunt = async (values, { resetForm }) => {
    try {
  const response = await ApiService.put(`/emprunts/${values.id}`, values);
  
  if (response.status === 200) {
    success(response.data.message);
    resetForm();
    router.push({ name: "ListeEmpruntPage" });
  }
} catch (err) {
  console.log(err);
  // error(err.response?.data?.message || "Une erreur est survenue.");
}
  };
  
      return { 
        empruntSchema, editEmprunt, empruntForm,documents,userOptions,documentOptions,showMErr
      };
    },
  });
  </script>